import React, { FC, useMemo } from 'react'
import './FilterCoursePagination.scss'
import { IoMdSkipBackward } from "react-icons/io";
import { IoChevronBackSharp } from "react-icons/io5";
import { IoIosArrowForward } from "react-icons/io";
import { IoMdSkipForward } from "react-icons/io";

interface IFilterCoursePaginationProps {
  pageNumber: number
  perPage: number
  total: number
  onChangePage: (newPage: number) => void
}

enum ArrowDirection {
  NEXT = 'next',
  PREV = 'prev'
}

const ARROW_COLOR = '#797984'
const ARROW_COLOR_DISABLED = '#a5a5a8'

const FilterCoursePagination: FC<IFilterCoursePaginationProps> = ({
  pageNumber,
  perPage,
  total,
  onChangePage
}) => {
  const itemsToRender: number[] = useMemo(() => {
    const totalPages = Math.ceil(total/perPage) ? Math.ceil(total/perPage) : 0
    const items = []
    for (let i=1; i<=totalPages; i++) {
      items.push(i)
    }
    return items
  }, [perPage, total])
  const isLimitPrev = pageNumber === 1
  const isLimitNext = pageNumber === itemsToRender.length

  const handleClickItem = (item: number) => {
    if (item === pageNumber) return
    onChangePage(item)
  }

  const onClickArrow = (direction: ArrowDirection) => {
    if (direction === ArrowDirection.PREV) {
      if (pageNumber > 1) {
        onChangePage(pageNumber-1)
      }
    }

    if (direction === ArrowDirection.NEXT) {
      if (pageNumber < itemsToRender.length) {
        onChangePage(pageNumber+1)
      }
    }
  }

  return (
    <div className='filter-course-pagination--container'>
      <IoMdSkipBackward
        color={isLimitPrev ? ARROW_COLOR_DISABLED : ARROW_COLOR}
        cursor={isLimitPrev ? 'initial' : 'pointer'}
        onClick={isLimitPrev ? undefined : () => handleClickItem(1)}
      />
      <IoChevronBackSharp
        color={isLimitPrev ? ARROW_COLOR_DISABLED : ARROW_COLOR}
        cursor={isLimitPrev ? 'initial' : 'pointer'}
        onClick={isLimitPrev ? undefined : () => onClickArrow(ArrowDirection.PREV)}
      />
        {itemsToRender.map(item => (
          <div
            key={item}
            onClick={() => handleClickItem(item)}
            className={`filter-course-pagination--number ${pageNumber === item ? 'filter-course-pagination--number-active' : ''}`}
          >
            {item}
          </div>
        ))}
      <IoIosArrowForward
        color={isLimitNext ? ARROW_COLOR_DISABLED : ARROW_COLOR}
        cursor={isLimitNext ? 'initial' : 'pointer'}
        onClick={isLimitNext ? undefined : () => onClickArrow(ArrowDirection.NEXT)}
      />
      <IoMdSkipForward
        color={isLimitNext ? ARROW_COLOR_DISABLED : ARROW_COLOR}
        cursor={isLimitNext ? 'initial' : 'pointer'}
        onClick={isLimitNext ? undefined : () => handleClickItem(itemsToRender.length)}
      />
    </div>
  )
}

export default FilterCoursePagination

